import { useMemo } from 'react';
import * as d3 from 'd3';

export const AxisY = ({ domain = [0, 100], range = [290, 10], unit = '%' }) => {
  // console.log(domain, range);
  const ticks = useMemo(() => {
    // range is reversed for yAxis so width calculation is also reversed
    const yScale = d3.scaleLinear().domain(domain).range(range);
    const width = range[0] - range[1];
    // console.log(width);
    const pixelsPerTick = 30;
    const numberOfTicksTarget = Math.max(1, Math.floor(width / pixelsPerTick));
    const stuff = yScale.ticks(numberOfTicksTarget).map((value) => ({
      value,
      yOffset: yScale(value),
    }));
    // console.log(stuff);
    return stuff;
  }, [domain.join('-'), range.join('-')]);
  return (
    <svg style={{ overflow: 'visible' }}>
      <path
        transform={`translate(0,0)`}
        // d="M 0 0 h 6 V 150 h -6"
        d={['M', -6, range[0], 'h', 6, 'V', range[1], 'h', -6].join(' ')}
        // d={['M', 0, range[0], 'h', 6, 'V', range[1], 'h', -6].join(' ')}
        fill="none"
        stroke="black"
        strokeWidth={1}
      />
      {ticks.map(({ value, yOffset }) => (
        <g key={value} transform={`translate(0, ${yOffset})`}>
          {/* <g key={value} transform={`translate(0, 10)`}> */}
          <line x2="-6" stroke="black" />
          <text
            key={value}
            style={{
              fontSize: '10px',
              textAnchor: 'middle',
              transform: 'translate(-30px,3px)',
              fill: 'currentcolor',
            }}
          >
            {value}
            {unit}
          </text>
        </g>
      ))}
    </svg>
  );
};
